import script from "./customersForm.vue?vue&type=script&setup=true&lang=js"
export * from "./customersForm.vue?vue&type=script&setup=true&lang=js"

import "./customersForm.vue?vue&type=style&index=0&id=1a8b3097&lang=css"

const __exports__ = script;

export default __exports__